import { format } from 'date-fns';

import { getSpeciesUrl } from '@domain/routes/urls';

interface CatchDetailsTableArgs {
  catchAndRelease: boolean | null | undefined;
  catchDate: string;
  convertedLength: string;
  convertedWeight: string;
  fishingMethod: string | undefined;
  speciesId: string | undefined;
  speciesName: string | undefined;
}

interface CatchDetailsTableData {
  detailName: string;
  detailValue: string;
  to: string | undefined;
}

export const getCatchDetailsTableData = ({
  catchAndRelease,
  catchDate,
  convertedLength,
  convertedWeight,
  fishingMethod,
  speciesId,
  speciesName,
}: CatchDetailsTableArgs): CatchDetailsTableData[] => [
  {
    detailName: 'Fish species',
    detailValue: speciesName ?? '-',
    to: !!speciesId && !!speciesName ? getSpeciesUrl(speciesId) : undefined,
  },
  {
    detailName: 'Weight',
    detailValue: convertedWeight,
    to: undefined,
  },
  {
    detailName: 'Length',
    detailValue: convertedLength,
    to: undefined,
  },
  {
    detailName: 'Date',
    detailValue: catchDate ? format(new Date(catchDate), 'yyyy-MM-dd') : '-',
    to: undefined,
  },
  {
    detailName: 'Method',
    detailValue: fishingMethod ?? '-',
    to: undefined,
  },
  {
    detailName: 'Catch and release',
    detailValue: catchAndRelease ? 'Yes' : catchAndRelease !== null ? 'No' : '-',
    to: undefined,
  },
];
